import { render } from "./VocationalFaithLeaders.vue?vue&type=template&id=545d67fe&scoped=true"
import script from "./VocationalFaithLeaders.vue?vue&type=script&lang=js"
export * from "./VocationalFaithLeaders.vue?vue&type=script&lang=js"

import "./VocationalFaithLeaders.vue?vue&type=style&index=0&id=545d67fe&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545d67fe"]])

export default __exports__